/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ApiKeyV2, ApiKeyV2WithKey } from "../../data/interfaces";

export const FETCH_API_KEYS_REQUEST = 'FETCH_API_KEYS_REQUEST';
export const FETCH_API_KEYS_SUCCESS = 'FETCH_API_KEYS_SUCCESS';
export const FETCH_API_KEYS_FAILURE = 'FETCH_API_KEYS_FAILURE';

export const GENERATE_API_KEY_REQUEST = 'GENERATE_API_KEY_REQUEST';
export const GENERATE_API_KEY_SUCCESS = 'GENERATE_API_KEY_SUCCESS';
export const GENERATE_API_KEY_FAILURE = 'GENERATE_API_KEY_FAILURE';

export const REGENERATE_API_KEY_REQUEST = 'REGENERATE_API_KEY_REQUEST';
export const REGENERATE_API_KEY_SUCCESS = 'REGENERATE_API_KEY_SUCCESS';
export const REGENERATE_API_KEY_FAILURE = 'REGENERATE_API_KEY_FAILURE';

export const DELETE_API_KEY_REQUEST = 'DELETE_API_KEY_REQUEST';
export const DELETE_API_KEY_SUCCESS = 'DELETE_API_KEY_SUCCESS';
export const DELETE_API_KEY_FAILURE = 'DELETE_API_KEY_FAILURE';


export interface ApiKeysActions {
    type: typeof FETCH_API_KEYS_REQUEST | typeof FETCH_API_KEYS_SUCCESS | typeof FETCH_API_KEYS_FAILURE
            | typeof GENERATE_API_KEY_REQUEST | typeof GENERATE_API_KEY_SUCCESS | typeof GENERATE_API_KEY_FAILURE
            | typeof REGENERATE_API_KEY_REQUEST | typeof REGENERATE_API_KEY_SUCCESS | typeof REGENERATE_API_KEY_FAILURE
            | typeof DELETE_API_KEY_REQUEST | typeof DELETE_API_KEY_SUCCESS | typeof DELETE_API_KEY_FAILURE,
    payload?: ApiKeyV2[] | ApiKeyV2WithKey | string
}
